export interface BatchTrcContentDetailUpdateRequest {
  startNumFrom: string
  startNumTo: string
  materialFormat: string
  convertHyoukiToFull: boolean
  convertKanaToHalf: boolean
  contentDetailTitleFile: string
  contentDetailDisplayAuthorFile: string
  memo: string
  batchType: string
}

export function BatchTrcContentDetailUpdateRequestToJSON(
  value: BatchTrcContentDetailUpdateRequest
): any {
  return {
    start_num_from: value.startNumFrom,
    start_num_to: value.startNumTo,
    material_format: value.materialFormat,
    convert_hyouki_to_full: value.convertHyoukiToFull,
    convert_kana_to_half: value.convertKanaToHalf,
    content_detail_title_file: value.contentDetailTitleFile,
    content_detail_display_author_file: value.contentDetailDisplayAuthorFile,
    memo: value.memo,
    batch_type: value.batchType
  }
}
